import { jsx as t } from "react/jsx-runtime";
import { forwardRef as s, useCallback as h } from "react";
import { Dropdown as v } from "./index.es72.js";
import { BasicDropdownMenu as b } from "./index.es73.js";
import { IconButton as B } from "./index.es16.js";
import { Button as I } from "./index.es15.js";
import { Spinner as m } from "./index.es70.js";
const w = s(
  ({
    hasChevron: o = !1,
    onClick: r,
    isLoading: n,
    text: a = "Open Report",
    disabled: c,
    isViewMode: e,
    CTAViewModeIcon: l,
    testId: p
  }, d) => {
    const g = h(
      (f) => {
        r == null || r(f), f.stopPropagation();
      },
      [r]
    ), u = {
      "aria-label": a,
      onClick: g,
      ref: d,
      disabled: c
    }, i = /* @__PURE__ */ t(m, { testId: p + "-spinner", variant: "white" });
    return e && l ? /* @__PURE__ */ t(
      B,
      {
        Icon: n ? i : l,
        variant: "ghost",
        testId: p + "-cta-icon-button",
        ...u
      }
    ) : /* @__PURE__ */ t(
      I,
      {
        testId: p + "-cta-button",
        fullWidth: !0,
        chevron: o ? { direction: "down" } : void 0,
        LeftIcon: n ? i : void 0,
        ...u,
        children: a
      }
    );
  }
), x = s(
  ({ items: o, onItemSelection: r, menuWidth: n, ...a }, c) => {
    const e = /* @__PURE__ */ t(w, { hasChevron: !!(o != null && o.length), ref: c, ...a });
    return o != null && o.length ? /* @__PURE__ */ t(
      v,
      {
        menuWidth: n,
        appendToParent: !0,
        scaleToAnchor: !n,
        closeOnSelection: !0,
        trigger: e,
        align: "start",
        children: /* @__PURE__ */ t(
          b,
          {
            onItemSelection: r,
            items: o,
            autoFocus: !1
          }
        )
      }
    ) : e;
  }
);
export {
  x as PoiDetailsItemActions
};
//# sourceMappingURL=index.es5542.js.map
